<template>
  <div class="w=100 referal-blue d-flex align-items-center position-relative">
    <div class="w-40 color-344054 fw-500 fs-14 font-mont">{{ label }}</div>
    <div class="font-mont fs-17 fw-700 color-mainblue w-55">{{ value }}</div>
    <div class="d-flex justify-content-end">
      <img
        src="../../assets/inputImgs/copy.svg"
        class="pointer"
        alt="copy"
        @click="copy"
      />
    </div>

    <transition name="fade">
      <div v-if="showCopied" class="copied-popup">Copied!</div>
    </transition>
  </div>
</template>

<script>
export default {
  name: "PromoCode",
  props: {
    label: String,
    id: { type: String, default: null },
    type: { type: String, default: "text" },
    value: String,
  },
  data() {
    return {
      showCopied: false,
    };
  },
  methods: {
    copy() {
      navigator.clipboard
        .writeText(this.value)
        .then(() => {
          this.showCopied = true;
          setTimeout(() => {
            this.showCopied = false;
          }, 2000);
          this.$emit("copied", this.value);
        })
        .catch((err) => {
          console.error("Failed to copy: ", err);
        });
    },
  },
};
</script>

<style scoped>
.referal-blue {
  background-color: #eef1f7;
  border-radius: 8px;
  padding: 10px;
}

.copied-popup {
  position: absolute;
  top: -30px;
  right: 10px;
  background: #4caf50;
  color: white;
  padding: 4px 10px;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 600;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
